// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d855a71b","667":"c4408e50","843":"49c7080a"}[chunkId] + ".chunk.js";
};